module.exports = __webpack_public_path__ + "static/media/icon1.4b6acc49.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/newpage/icon1.png
// module id = 215
// module chunks = 0